import { render, staticRenderFns } from "./AverageDurationPage.vue?vue&type=template&id=f1ad5da2&scoped=true"
import script from "./AverageDurationPage.vue?vue&type=script&lang=js"
export * from "./AverageDurationPage.vue?vue&type=script&lang=js"
import style0 from "./AverageDurationPage.vue?vue&type=style&index=0&id=f1ad5da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ad5da2",
  null
  
)

export default component.exports